import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { initSessionSuccess, startSessionSuccess } from '../actions/session.actions';
import { Bank, BankCountry } from '../../services/interfaces/bank.interface';
import { chooseBank } from '../thunks/bank-selection.thunk';

export interface BankSliceState {
	bankName: string | null;
	bankCode: string | null;
	countryCode: string | null;
	logo: string | null;
}

const initialState: BankSliceState = {
	bankName: null,
	bankCode: null,
	countryCode: null,
	logo: null
};

export const bankSlice = createSlice({
	name: 'session/bank',
	initialState,
	reducers: {
		saveSessionBank(_, action: PayloadAction<{ bank: Bank; country: BankCountry }>) {
			const { bank, country } = action.payload;
			return {
				bankName: bank.name,
				bankCode: bank.bankCodes[0],
				countryCode: country,
				logo: bank.logo || null
			};
		}
	},
	extraReducers: (builder) => {
		builder.addCase(initSessionSuccess, (state, action) => {
			const session = action.payload;
			const bank = session.bank;
			if (!bank) return state;
			return {
				bankName: bank.bankName,
				bankCode: bank.bankCode,
				countryCode: bank.countryCode,
				logo: bank.logo || null
			};
		});

		builder.addCase(chooseBank.fulfilled, (_, action) => {
			const { bank, country } = action.payload;
			return {
				bankName: bank.name,
				bankCode: bank.bankCodes[0],
				countryCode: country,
				logo: bank.logo || null
			};
		});
		builder.addCase(startSessionSuccess, (state, action) => {
			const { bank } = action.payload;
			if (!bank) {
				return state;
			}
			return {
				bankName: bank.name,
				bankCode: bank.bankCodes[0],
				countryCode: bank.country,
				logo: bank.logo || null
			};
		});
	}
});

export const selectSessionBankName = (state: RootState) => state.bank.bankName;
export const selectSessionBankCode = (state: RootState) => state.bank.bankCode;
export const selectSessionBankLogo = (state: RootState) => state.bank.logo;

export const { saveSessionBank } = bankSlice.actions;
